function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.8163 22.7349C35.8777 14.7753 30.5716 10 23.1428 10C15.7144 10 12 15.2851 12 21.1219C12 26.9586 16.0784 27.656 16.0784 32.4314C16.0784 35.6151 16.0784 38.0392 16.0784 38.0392L28.8235 39.0588V36C32.538 37.0614 34.2856 34.9386 34.2856 34.9386L35.347 29.1018C37.4693 28.5716 38 27.5102 38 27.5102C38 27.5102 34.8163 23.2651 34.8163 22.7349ZM28.8235 22.7451L25.1983 23.1983L24.7451 26.8235H22.7059L22.2527 23.1983L18.6275 22.7451V20.7059L22.2527 20.2527L22.7059 16.6275H24.7451L25.1983 20.2527L28.8235 20.7059V22.7451Z"
});

function SvgIc5D5F53AaFc0611Eb9A030242Ac130003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5D5F53AaFc0611Eb9A030242Ac130003);
export default ForwardRef;